import React, { useEffect, useState } from "react";
import { BaseModal } from "./FormElements/BaseModal";
import { InputSelect } from "./FormElements/InputSelect";
import Button from "./FormElements/Button";

interface IModalFormBeneficiarie {
  relationship: any;
  open: boolean;
  onSubmit: () => void;
  close: () => void;
  register: any;
  selectedParient: any;
  errors?: any;
  salud: any;
  genrer: any;
  disabledSend: boolean;
  disabledGenrer?: boolean;
}

export const ModalFormBeneficiaries = ({
  relationship,
  open,
  onSubmit,
  close,
  register,
  selectedParient,
  salud,
  genrer,
  disabledSend,
  disabledGenrer,
}: IModalFormBeneficiarie) => {
  const beneficiary = selectedParient || {};
  const [bornDate, setBornDate] = useState(beneficiary.bornDate || "");

  useEffect(() => {
    if (!open) {
      setBornDate("");
      return;
    }

    setBornDate((selectedParient && selectedParient.bornDate) || "");
  }, [open, selectedParient]);

  const formatBornDate = (event: React.ChangeEvent<HTMLInputElement>) => {
    const digits = event.target.value.replace(/\D/g, "").slice(0, 8);
    const parts = [digits.slice(0, 2), digits.slice(2, 4), digits.slice(4, 8)]
      .filter(Boolean);
    setBornDate(parts.join("/"));
  };

  return (
    <BaseModal
      open={open}
      handleClose={close}
      title="Agregar Beneficiario"
      width={`${window.innerWidth}px`}
    >
      <form
        style={{ display: "flex", flexDirection: "column", gap: "16px" }}
        onSubmit={onSubmit}
        className="p-0"
      >
        <InputSelect
          name="relationship"
          options={relationship}
          placeHolder="Parentesco"
          register={register}
          defaultValue={beneficiary.relationship || ""}
        />
        <div className="clientForm__control input-field m-0">
          <input type="hidden" name="bornDate" ref={register} value={bornDate} readOnly />
          <input
            key={beneficiary.id || "new-beneficiary"}
            id="bornDate"
            value={bornDate}
            autoComplete="off"
            type="text"
            inputMode="numeric"
            maxLength={10}
            onChange={formatBornDate}
          />
          <label className={bornDate ? "active" : ""} htmlFor="bornDate">
            Fecha de nacimiento (dd/mm/yyyy)
          </label>
        </div>
        <InputSelect
          name="sano"
          options={salud}
          placeHolder="Salud"
          register={register}
          defaultValue={beneficiary.sano || ""}
        />
        <InputSelect
          name="genrerBenefiarie"
          options={genrer}
          placeHolder="Sexo"
          register={register}
          defaultValue={beneficiary.genrerBenefiarie || ""}
          disabled={disabledGenrer}
        />
        <div style={{ display: "flex", justifyContent: "end" }}>
          <div style={{ width: "50%" }}>
            <Button type="submit" disabled={disabledSend}>
              {selectedParient ? "Editar" : "Aceptar"}
            </Button>
          </div>
        </div>
      </form>
    </BaseModal>
  );
};
